import React from 'react';
import { connect } from 'react-redux';
import objectPath from 'object-path';
import * as builder from '../../ducks/builder';

class Footer extends React.Component {
  render() {
    return (
      <div
        className={`kt-footer ${this.props.footerClasses} kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop`}
        id="kt_footer"
        style={{ zIndex: '-1' }}
      >
        <div className={`kt-container ${this.props.footerContainerClasses}`}>
          <div className="kt-footer__copyright">
            <span className="mr-2">تمامی حقوق سایت متعلق به مهرپارس است. &copy; 1400</span>
            <a
              href={`${process.env.REACT_APP_DARSUP_URL}`}
              target="_blank"
              rel="noopener noreferrer"
              className="kt-link"
            >
              درس‌آپ
            </a>
          </div>
          {/*<div className="kt-footer__menu">*/}
          {/*  <a*/}
          {/*    href={`${process.env.REACT_APP_LMS_URL}/honor`}*/}
          {/*    target="_blank"*/}
          {/*    rel="noopener noreferrer"*/}
          {/*    className="kt-footer__menu-link kt-link"*/}
          {/*  >*/}
          {/*    قوانین*/}
          {/*  </a>*/}
          {/*  <a*/}
          {/*    href={`${process.env.REACT_APP_LMS_URL}/privacy`}*/}
          {/*    target="_blank"*/}
          {/*    rel="noopener noreferrer"*/}
          {/*    className="kt-footer__menu-link kt-link"*/}
          {/*  >*/}
          {/*    سیاست‌های حفظ حریم خصوصی*/}
          {/*  </a>*/}
          {/*</div>*/}
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  fluid: objectPath.get(store.builder.layoutConfig, 'footer.self.width') === 'fluid',
  footerClasses: builder.selectors.getClasses(store, {
    path: 'footer',
    toString: true,
  }),
  footerContainerClasses: builder.selectors.getClasses(store, {
    path: 'footer_container',
    toString: true,
  }),
});

export default connect(mapStateToProps)(Footer);
